export const DIRECT_CHAT_TYPE = {
  DIRECT: 'DIRECT',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
} as const;

export type DirectChatType =
  (typeof DIRECT_CHAT_TYPE)[keyof typeof DIRECT_CHAT_TYPE];

export const DIRECT_THREAD_LABEL = 'This is a direct message thread';

export const ANNOUNCEMENT_THREAD_LABEL =
  "It's a message from Trusted Herd Admin";

export function isAnnouncementChat(chat: {
  type?: string | null;
  isAnnouncement?: boolean | null;
}): boolean {
  return (
    chat.isAnnouncement === true || chat.type === DIRECT_CHAT_TYPE.ANNOUNCEMENT
  );
}
